import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';

const FileUpload = ({ onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
   const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [fileToReplace, setFileToReplace] = useState(null);
  const [uploadMessage, setUploadMessage] = useState(null);
  const [docType, setDocType] = useState(null);


  const token = localStorage.getItem("token");

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    if (!token) {
      alert("You must log in before uploading files.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post("https://bank-converter-app-3.onrender.com/upload", formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
              },
        timeout: 1800000, // ✅ 3 minutes timeout to handle large PDFs
        maxContentLength: Infinity, // ✅ for large multi-page docs
        maxBodyLength: Infinity,

      });

      setUploadResult(response.data);
      onUploadSuccess(response.data);
    } catch (error) {
       if (error.response?.status === 409) {
    // File already exists → show replace modal
        setFileToReplace(file);
        setShowReplaceModal(true);
      } else {
        console.error("Upload failed:", error.response?.data || error.message);
        setUploadResult({ error: error.response?.data?.detail || "Upload failed" });
      }
      } finally {
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "image/*": [".png", ".jpg", ".jpeg"],
    },
    multiple: false,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        style={{
          border: "2px dashed #ccc",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        {uploading ? (
          <p>Uploading...</p>
        ) : isDragActive ? (
          <p>Drop the file here...</p>
        ) : (
          <p>Drag & drop a bank statement, or click to select</p>
        )}
      </div>
    {showReplaceModal && (
    <div style={{
    position: "fixed",
    top:0, left:0, right:0, bottom:0,
    backgroundColor:"rgba(0,0,0,0.5)",
    display:"flex", alignItems:"center", justifyContent:"center",
    zIndex: 9999
    }}>
    <div style={{
      background:"white",
      padding:"30px",
      borderRadius:"10px",
      textAlign:"center",
      maxWidth:"400px",
      width:"90%"
    }}>
      <p>A file named <strong>{fileToReplace?.name}</strong> already exists. Replace it?</p>
      <div style={{ marginTop:"20px" }}>
        <button
          style={{ marginRight:"10px", padding:"10px 20px" }}
          onClick={async () => {
            setShowReplaceModal(false);
            setUploading(true);
            const replaceForm = new FormData();
            replaceForm.append("file", fileToReplace);
            replaceForm.append("replace", "true");
            try {
              const response = await axios.post("https://bank-converter-app-3.onrender.com/upload", replaceForm, {
                headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "multipart/form-data"
                },
                timeout: 1800000, // ✅ 3 minutes timeout to handle large PDFs
                maxContentLength: Infinity, // ✅ for large multi-page docs
                maxBodyLength: Infinity,

              });
              setUploadResult(response.data);
              onUploadSuccess(response.data);
            } catch (err) {
              setUploadResult({ error: err.response?.data?.detail || "Upload failed" });
            } finally {
              setUploading(false);
              setFileToReplace(null);
            }
          }}
        >
          Replace
        </button>
        <button
          style={{ padding:"10px 20px" }}
          onClick={() => { setShowReplaceModal(false); setFileToReplace(null); }}
        >
          Cancel
        </button>
      </div>
    </div>
    </div>
    )}

      {uploadResult && (
        <div style={{ marginTop: "20px", padding: "10px", backgroundColor: "#f5f5f5" }}>
          {uploadResult.error ? (
            <p style={{ color: "red" }}>❌ {uploadResult.error}</p>
          ) : (
            <>
              <p>✅ Upload and Processing Completed</p>
               {uploadResult.ai_validation && (
              <div style={{
                marginTop: "15px",
                padding: "15px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#f0f9ff"
              }}>
                <h3>🤖 Claude AI Insights</h3>

                {uploadResult.ai_validation.validation_passed && (
                  <p style={{color: "green"}}>✅ All transactions validated</p>
                )}

                {uploadResult.ai_validation.anomalies?.length > 0 && (
                  <div style={{color: "orange"}}>
                    ⚠️ {uploadResult.ai_validation.anomalies.length} anomalies detected
                  </div>
                )}

                {uploadResult.ai_validation.insights && (
                  <div style={{marginTop: "10px", fontSize: "14px"}}>
                    <strong>Spending Pattern:</strong>
                    <p>{uploadResult.ai_validation.insights}</p>
                  </div>
                )}
              </div>
            )}

            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
